export const CheckIconExtraThick = ({
  width = 24,
  height = 24,
  color = "white",
}: {
  width?: number;
  height?: number;
  color?: string;
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 11.3505L9.08696 17.913L21 6.00004" stroke={color} />
  </svg>
);
